import api from 'api';
import {get} from 'lodash';
import {useState} from 'react';
import {useForm} from 'react-hook-form';
import toast from 'react-hot-toast';
import {useHistory, useLocation} from 'react-router-dom';

interface FormValues {
  title: string;
  content: string;
  is_active: boolean;
}

function useFormComponent() {
  const {goBack} = useHistory();
  const {state} = useLocation<{sharedDefaultValue?: string}>();
  const defaultTitle = state?.sharedDefaultValue || '';
  const {
    control,
    handleSubmit,
    setValue: setFieldValue,
    formState: {errors},
  } = useForm<FormValues>({
    defaultValues: {
      is_active: true,
      title: defaultTitle,
    },
  });
  const [loading, setLoading] = useState(false);

  const createHandler = (data: FormValues) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('title', data.title);
    formData.append('slug', data.title.toLowerCase().replace(/ /g, '-'));
    formData.append('content', data.content);
    formData.append('content_type', 'template');
    formData.append('is_active', data.is_active ? 'true' : 'false');
    api
      .post('/support/templates/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        goBack();
        setLoading(false);
      })
      .catch((err) => {
        const errorObj = get(err, 'response.data', {});
        const errors = Object.keys(errorObj).map(
          (key) => key + ': ' + errorObj[key]
        );
        toast.error(errors.join('\n'));
        setLoading(false);
      });
  };

  return {
    control,
    errors,
    loading,
    createHandler: handleSubmit(createHandler),
    setFieldValue,
  };
}

export default useFormComponent;
